"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslatableTemplate = void 0;
const regTemplate = /%s/;
class TranslatableTemplate {
    constructor(supplier, def, content = [], translations = {}) {
        this.supplier = supplier;
        this.def = def;
        this.content = content;
        this.translations = translations;
        this.message = "";
        this.messageHTML = "";
        this.generated = false;
        this.generatedHTML = false;
    }
    getMessage(entities = false) {
        if (entities) {
            if (!this.generatedHTML) {
                this.messageHTML = this.generate(entities);
                this.generatedHTML = true;
            }
            return this.messageHTML;
        }
        else {
            if (!this.generated) {
                this.message = this.generate(entities);
                this.generated = true;
            }
            return this.message;
        }
    }
    getKey() {
        let ret = this.def.key;
        if (ret === "httpError" || ret === "httpErrorShort") {
            ret += ":" + this.content[0];
        }
        return ret;
    }
    generate(entities) {
        let msg;
        msg = (this.translations && this.translations[this.def.key]) ? this.translations[this.def.key] : this.def.template;
        let n = 0;
        let content;
        if (this.translations.templateContent) {
            content = [];
            for (const contentValue of this.content) {
                if (this.translations.templateContent[contentValue]) {
                    content.push(this.translations.templateContent[contentValue]);
                }
                else {
                    content.push(contentValue);
                }
            }
        }
        else {
            content = this.content;
        }
        while (n < content.length && msg.match(regTemplate)) {
            let contentItem = content[n++];
            if (this.supplier) {
                if (typeof (contentItem) === "number") {
                    contentItem = this.supplier.niceInt(contentItem);
                }
                else if (typeof (contentItem) === "string") {
                    contentItem = (entities) ? this.supplier.htmlEntities(contentItem) : contentItem;
                }
            }
            msg = msg.replace(regTemplate, contentItem);
        }
        return msg;
    }
}
exports.TranslatableTemplate = TranslatableTemplate;
